import {i18n} from '@netx/core/i18n';

export const AssetExpirationListLabel = {
	ROUTE: i18n.t('i18n.expiringAssets'),
};

export const ASSET_EXPIRATION_ACTION_LABELS = {
	EXPIRE: i18n.t('i18n.expire'),
	UNEXPIRE: i18n.t('i18n.unexpire'),
};

export const ASSET_EXPIRATION_CONFIRMATIONS = <const>{
	UNEXPIRE: i18n.t('i18n.unexpireConfirm'),
};

export const ASSET_EXPIRATION_SUBMIT_LABELS = <const>{
	EXPIRE: i18n.t('i18n.expire'),
	UNEXPIRE: i18n.t('i18n.unexpire'),
};

export const ASSET_EXPIRATION_TITLES = <const>{
	EXPIRE: i18n.t('i18n.setExpiration'),
};
